import { ShipmentData, SHIPPING_PROVIDERS } from "../../../../types/shipments";
import { ART_URL, SHIPMENT_URL } from "../../config";
import { ArtList } from "../ArtList";
import { ButtonLink } from "../Button";

export function ShipmentDetails({
  shipment,
  showViewShipmentBtn,
  showItems,
  admin,
  className = " border-primary bg-main ",
}: {
  shipment: ShipmentData;
  showViewShipmentBtn?: boolean;
  showItems?: boolean;
  admin?: boolean;
  className?: string;
}) {
  return shipment ? (
    <div className={"px-5 py-2 my-2 border-solid border-2 " + className}>
      <h1 className="font-bold">Shipment #{shipment.slug}</h1>

      <div className="flex flex-col-reverse md:flex-row justify-start my-2">
        <div className="basis-6/12">
          <div className="font-bold">Shipped</div>
          <div>{shipment.isShipped ? "Shipped" : "Not shipped"}</div>
          <div className="font-bold">Shipping provider</div>
          <div>
            {shipment.shippingProvider?.type
              ? shipment.shippingProvider.type
              : "No shipping provider provided"}
          </div>

          {shipment.shippingProvider ? (
            <div>
              {shipment.shippingProvider.type ===
              SHIPPING_PROVIDERS.NONE ? null : shipment.shippingProvider
                  .type === SHIPPING_PROVIDERS.OTHER ? (
                <>
                  <div className="font-bold">Name</div>
                  <div>{shipment.shippingProvider.name} </div>
                  <div className="font-bold">Contact info</div>
                  <div>{shipment.shippingProvider.contactInfo} </div>
                </>
              ) : (
                <>
                  <div className="font-bold">Tracking number</div>
                  <div>{shipment.shippingProvider.trackingNumber}</div>
                </>
              )}
            </div>
          ) : null}
        </div>
        <div className="basis-2/12">
          <div className="font-bold">Created</div>
          <div>
            {shipment.createdAt
              ? Intl.DateTimeFormat("en-us", {
                  hour12: true,
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                }).format(new Date(shipment.createdAt))
              : "No created at date"}
          </div>
        </div>
      </div>

      {showItems ? (
        <div>
          <ArtList
            items={shipment.items}
            getArtConfig={(art) => ({
              height: 100,
              hoverHeight: 200,
              href: ART_URL(art.slug, admin),
            })}
          />
        </div>
      ) : null}
      {showViewShipmentBtn ? (
        <div>
          <ButtonLink
            btnType="small"
            btnColor="secondary"
            href={SHIPMENT_URL(shipment.slug, admin, shipment.orderSlug)}
          >
            View Shipment
          </ButtonLink>
        </div>
      ) : null}
    </div>
  ) : (
    <div className="px-5 py-2 my-2 border-solid border-2 border-primary bg-accent">
      NO SHIPMENTS
    </div>
  );
}
